export const DividerRow = () => {
	return (
		<tr className="air-table-divider-row">
			<td colSpan={6} />
		</tr>
	);
};
